import { jsxs, jsx } from "react/jsx-runtime";
const ToggleIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx("path", { d: "M670,232H354C193.84,232,64,361.84,64,522S193.84,812,354,812H670c160.16,0,290-129.84,290-290S830.16,232,670,232Zm0,508H354c-120.4,0-218-97.6-218-218s97.6-218,218-218H670c120.4,0,218,97.6,218,218S790.4,740,670,740Z" }),
  /* @__PURE__ */ jsx("path", { d: "M670,368A154,154,0,1,0,824,522,154,154,0,0,0,670,368Zm0,236a82,82,0,1,1,82-82A82,82,0,0,1,670,604Z" })
] });
export {
  ToggleIcon
};
